import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { getToken, removeToken } from '@/plugins/cookie'
import { ElMessage } from 'element-plus'

export class Request {
  public static axiosInstance: AxiosInstance

  public static init () {
    // 创建axios实例
    this.axiosInstance = axios.create({
      baseURL: process.env.VUE_APP_API_URL
      // timeout: 6000
    })
    // 初始化拦截器
    this.initInterceptors()
    return axios
  }

  // 初始化拦截器
  public static initInterceptors () {
    // 设置post请求头
    // this.axiosInstance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    /**
     * 请求拦截器
     * 每次请求前，如果存在token则在请求头中携带token
     */
    this.axiosInstance.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        // 登录流程控制中，根据本地是否存在token判断用户的登录情况
        // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
        // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
        if (getToken()) {
          config.headers['token'] = getToken()
        }
		config.headers['App'] = 'xjy'
        // 日志处理
        // let logoInfo = {
        //   content: config.url,
        //   system: getOS(),
        //   model: localStorage.getItem("moduletitle")
        //     ? localStorage.getItem("moduletitle")
        //     : "未知",
        //   params: JSON.stringify(config.data)
        //     ? JSON.stringify(config.data)
        //     : "",
        // };
        // let encoded = btoa(
        //   unescape(encodeURIComponent(JSON.stringify(logoInfo)))
        // );
        // console.log(encoded);
        // config.headers["log"] = encoded;
        return config
      },
      (error: any) => {
        console.log(error)
      }
    )

    // 响应拦截器
    this.axiosInstance.interceptors.response.use(
      // 请求成功
      (response: AxiosResponse) => {
        const status = response.status
        const res = response.data
        let msg = ''
        switch (true) {
          case status < 200 || status > 300:
            Request.errorHandle(response)
            break
          case res.code === 200:
            break
          case res.code === 40001:
            // removeToken()
            // location.reload()
            break
          default:
            ElMessage.error(res.message)
            break
        }
        return response
      },
      // 请求失败
      (error: any) => {
        const { response } = error
        if (response) {
          // 请求已发出，但是不在2xx的范围
          Request.errorHandle(response)
          return Promise.reject(response.data)
        } else {
          // 处理断网的情况
          // eg:请求超时或断网时，更新state的network状态
          // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
          // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
          ElMessage({
            message: '网络连接异常,请稍后再试!',
            type: 'error'
          })
        }
      }
    )
  }

  /**
   * http握手错误
   * @param res 响应回调,根据不同响应进行不同操作
   */
  private static errorHandle (res: any) {
    // 状态码判断
    switch (res.status) {
      case 401:
        break
      case 403:
        break
      case 404:
        ElMessage({
          message: '请求的资源不存在',
          type: 'warning'
        })
        break
      default:
        ElMessage.error({ duration: 600, offset: 200, message: '连接错误' })
    }
  }
}

function getOS () {
  var userAgent = navigator.userAgent,
    platform = navigator.platform,
    macOS = /Mac OS X/.test(userAgent),
    windows = /Win32/.test(platform),
    ios = /iPad|iPhone|iPod/.test(userAgent) && !windows,
    android = /Android/.test(userAgent)

  if (macOS) return 'Mac OS'
  if (windows) return 'Windows'
  if (ios) return 'iOS'
  if (android) return 'Android'

  return 'Unknown OS'
}
